(function() {
    'use strict';

    angular
        .module('app.puestos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/puestos',
                config: {
                    templateUrl: 'app/puestos/puestos.html',
                    controller: 'Puestos',
                    controllerAs: 'vm',
                    title: 'Puestos'
                }
            },
            {
                url: '/editar-puesto/:id?',
                config: {
                    templateUrl: 'app/puestos/editarPuesto.html',
                    controller: 'EditarPuesto',
                    controllerAs: 'vm',
                    title: 'EditarPuesto'
                }
            }
        ];
    }
})();
